import { useEffect, useRef, useState } from 'react';
import Api from 'api';

const defaultState = {
  loading: false,
  valid: true,
  disallowedPrefix: null,
  error: null,
};

const useValidateNaturalUserEmail = (email, enabled = true) => {
  const [state, setState] = useState(defaultState);
  const lastEmailRef = useRef(null);

  useEffect(() => {
    if (!enabled) {
      lastEmailRef.current = null;
      setState(defaultState);
      return;
    }

    const trimmedEmail = (email || '').trim();
    if (!trimmedEmail) {
      lastEmailRef.current = null;
      setState({
        loading: false,
        valid: false,
        disallowedPrefix: null,
        error: 'invalid_format',
      });
      return;
    }

    if (lastEmailRef.current === trimmedEmail) {
      return;
    }

    lastEmailRef.current = trimmedEmail;
    let isActive = true;
    setState((prev) => ({
      ...prev,
      loading: true,
    }));

    Api.validateNaturalUserEmail(trimmedEmail)
      .then((res) => {
        if (!isActive) {
          return;
        }
        setState({
          loading: false,
          valid: !!res?.valid,
          disallowedPrefix: res?.disallowedPrefix || null,
          error: null,
        });
      })
      .catch((err) => {
        if (!isActive) {
          return;
        }
        const isInvalidFormat = err?.status === 400;
        setState({
          loading: false,
          valid: false,
          disallowedPrefix: null,
          error: isInvalidFormat ? 'invalid_format' : 'unknown',
        });
      });

    return () => {
      isActive = false;
    };
  }, [email, enabled]);

  return state;
};

export default useValidateNaturalUserEmail;
